import tryOnUnMounted from './use/try-on-unmounted';

/**
 * Listens to VueEventBus event and automatically unregisters when component unmounts
 * @param {String} eventName
 * @param {Function} callback
 */
function $on(eventName, callback) {
  window?.VueEventBus?.$on(eventName, callback);
  tryOnUnMounted(() => {
    window?.VueEventBus?.$off(eventName, callback);
  });
}

function $off(eventName, callback) {
  window?.VueEventBus?.$off(eventName, callback);
}

function $emit(...args) {
  window?.VueEventBus?.$emit(...args);
}

function $once(eventName, callback) {
  window?.VueEventBus?.$once(eventName, callback);
  tryOnUnMounted(() => {
    window?.VueEventBus?.$off(eventName, callback);
  });
}

function $offByIframe(iframeName) {
  window?.VueEventBus?.$offByIframe(iframeName);
}

const eventBus = {
  $on,
  $off,
  $emit,
  $once,
  $offByIframe,
};

export default function getVueEventBus() {
  return eventBus;
}
